export const CODE_PAGE_TRANG_CHU = `20211005104618926`;
export const CODE_PAGE_QUAN_LY_GIAI_PHAP_DAU_TU = `20221026132734948`;
// export const CODE_PAGE_QUAN_LY_DAU_TU_HOME = `20220915145257442`

// Ve chung toi
export const CODE_PAGE_VE_CHUNG_TOI = `20211005104752301`;
export const CODE_PAGE_GIOI_THIEU = `20211005160626042`;
export const CODE_PAGE_DOI_NGU_LANH_DAO = `20211005160819957`;
export const CODE_PAGE_QUAN_HE_CO_DONG = `20211005160837837`;
export const CODE_PAGE_TRIET_LY_DAU_TU = `20211005160928296`;
export const CODE_PAGE_DOI_TAC_CUA_CHUNG_TOI = `20211122203625256`;

// Truyen thong
export const CODE_PAGE_TRUYEN_THONG = `20211005104822280`;
export const CODE_PAGE_TIN_TUC = `20211005105015226`;
export const CODE_PAGE_SU_KIEN = `20211005105050570`;
export const CODE_PAGE_THONG_CAO_BAO_CHI = `20211215163458654`;

// Quy dau tu
export const CODE_PAGE_QUY_DAU_TU = `20220902133948303`;
export const CODE_PAGE_QUAN_LY_DANH_MUC_DAU_TU = `20220902134041201`;
export const CODE_PAGE_TU_VAN_DAU_TU = `20220902134052778`;

// Kien thuc dau tu
export const CODE_PAGE_KIEN_THUC_DAU_TU = `20220902134110772`;
export const CODE_PAGE_CONG_CU_DAU_TU = `20220902135058029`;
export const CODE_PAGE_GOC_NHIN_DAU_TU = `20220902135017725`;
export const CODE_PAGE_KIEN_THUC_CO_BAN = `20220902135041584`;

// Cong bo thong tin
export const CODE_PAGE_CONG_BO_THONG_TIN = `20220902135116753`;

// Ho tro
export const CODE_PAGE_HO_TRO = `20220902135240259`;
export const CODE_PAGE_LIEN_HE = `20220902135306102`;
export const CODE_PAGE_CAU_HOI_THUONG_GAP = `20220902135322637`;
export const CODE_PAGE_HO_TRO_TU_VAN_TAI_CHINH = `20220902135344858`;

// Tuyen dung
export const CODE_PAGE_TUYEN_DUNG = `20220902135401422`;

// Dieu khoan su dung
export const CODE_PAGE_DIEU_KHOAN_SU_DUNG = `20220902135415527`;
export const CODE_PAGE_QUAN_LY_DIEU_KHOAN_SU_DUNG = `20220915104142823`;

// Quyen mien tru
export const CODE_PAGE_QUYEN_MIEN_TRU = `20220902135431154`;

// Page not found
export const CODE_PAGE_NOT_FOUND = `99999999999999999`;

// Page search
export const CODE_PAGE_SEARCH = `99999999999999990`;
